var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height justify-center"},[_c('user-login',{staticStyle:{"max-width":"400px"},on:{"close":function($event){return _vm.$router.push('/')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }